<template>
  <ul class="nav nav-tabs custom-tab" role="tablist">
    <li
      class="nav-item"
      v-on:click="changetab(item.value)"
      v-for="(item, index) in list"
      :key="index"
    >
      <a
        class="nav-link"
        :class="{ 'show active': showtab === item.value }"
        :id="item.id"
        data-bs-toggle="tab"
        role="tab"
        :aria-controls="item.value"
        aria-selected="false"
        >{{ item.label }}</a
      >
    </li>
  </ul>
</template>
<style lang="scss" scoped>
.custom-tab {
  width: auto;
  display: inline-flex;
  overflow: hidden;
  border-radius: 40px;
  background: #fff;

  .nav-item {
    background-color: #fff;
    width: max-content;
    height: 51px;
    margin: 0 5px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 20px;

    .nav-link {
      border: none;
      padding: 10px 20px;
      cursor: pointer;
      color: #9b9a9a;
      font-family: Inter;
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      height: 42px;
      background: #fff;
      border-radius: 21px;
      &.active {
        background: #218863;
        color: white;
      }
    }

    &.show,
    &.active {
      background: #218863;
    }
  }
}
</style>

<script>
export default {
  props: ["items", "active", "path"],
  watch: {
    items: {
      handler: function (val) {
        this.list = val;
      },
      immediate: true,
    },
    active: {
      handler: function (val) {
        this.showtab = val;
      },
      immediate: true,
    },
  },
  data() {
    return {
      list: [],
      showtab: "",
    };
  },
  methods: {
    changetab(tab) {
      this.showtab = tab;
      this.$router.push((this.path || "/scheduler/") + tab);
    },
  },
};
</script>